// extracted by mini-css-extract-plugin
export default {"AccTraceabilityTab":"HfkbCN1TmfhobPQPYSwiJQ==","configTitle":"BpV4iG64x-6cbwjjWKypKg=="};